import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux"
import moment from "moment";

import { Modal, Icon, Tabs, Checkbox, Button } from "antd";
import { Http } from "../../../../../../helpers/axois";

// import "./css/app.css"
import style from "../../../../Assisted/forms/list.module.sass";
import Form from "../../../forms/Form";
import SoloFrom from "../../../../Solo/forms/Form"
import { ModalSelectedValue } from "../../../../../../stateManager/store/solo/action";
import { AppState } from "../../../../../../stateManager/store";
import SearchBar, { highlightMatch } from "../../../../../../helpers/SearchBar";
import { updateFormCoreVersion } from "../../../../../../stateManager/store/apps/actions";

const { TabPane } = Tabs;

interface FormmodelProps {
  visible: boolean;
  getForms?: () => void;
  setvisible: (status: boolean) => void;
  appId: any;
  branchId?: any;
  seletedAppType?: string;
  // editInitialData?: {};
  editable?: boolean;
  soloSelectedNodeId?: string;
  appVersion: { currentVersion: boolean; versionId: string };
  getSavedForm: (Saveform: any, select?: string) => void;
  selectedFromKey?: string;
}
let onSubmit: any;
export const FormModal = ({
  visible,
  getForms,
  setvisible,
  appId,
  branchId,
  appVersion,
  seletedAppType,
  // editInitialData,
  editable,
  getSavedForm,
  soloSelectedNodeId,
  selectedFromKey,
}: FormmodelProps) => {
  let [forms, setforms]: any = useState([]);
  let [selFrom, setSelFrom]: any = useState("");
  let [activeTab, setActiveTab]: any = useState("1");
  const {guideVisible} = useSelector((state: AppState) => state.onboarding)
  const dispatch = useDispatch()
  const selectedValRef = useRef(selectedFromKey);
  const [filteredData, setFilterData] = useState<any[]>([])
  const searchRef = useRef<{ clearSearch: () => void }>(null);
  const [searchValue, setSearchValue] = useState<string>("")
  useEffect(() => {
    // const currentVersion = appVersion && appVersion.currentVersion;
    selectedValRef.current = selectedFromKey;
    const versionId = appVersion && appVersion.versionId;
    Http.get(`/apps/${appId}/forms?versionId=${versionId}&branchId=${branchId}`).subscribe((formRes: any) => {
      selectedFromKey &&
        formRes.map((form: any) => {
          if (form.formKey === selectedValRef.current) {
            setSelFrom(form);
          }
          return 0;
        });
        if (guideVisible) {
          setActiveTab('2')
        } 
      setFilterData(formRes)
      setforms(formRes);
    });
  }, [appId, appVersion, selectedFromKey, branchId]);

  useEffect(() => {
    if (soloSelectedNodeId) {
      dispatch(ModalSelectedValue({
        id: soloSelectedNodeId,
        name: selFrom && selFrom.displayName
      }))
    }
  }, [selFrom, dispatch, soloSelectedNodeId])

  const SoloSelectedForms = () => {
    getSavedForm([selFrom], "select")
    if (soloSelectedNodeId) {
      dispatch(ModalSelectedValue({
        id: soloSelectedNodeId,
        name: selFrom && selFrom.displayName
      }))
    }
    dispatch(updateFormCoreVersion(selFrom.coreVersion));
    setvisible(false);
  }
  const column = [
    {dataIndex: "formName"},
    {dataIndex: "updatedat"},
    {dataIndex: "createdByName"},
    {dataIndex: "formVersion"}
  ]
  return (
    <Modal
      data-test-id="form_modal"
      width={676}
      maskClosable={false}
      className={`${style.model} OpenFormModal Bpmn_Create_Modal card-container`}
      bodyStyle={{
        height:'calc(100vh - 300px)',
        overflowY: "auto"
      }}
      title={
        <div className={style.searchModalHeader}> 
          Form Tasks 
          {activeTab == '1' && (
            <SearchBar
              mode="modal"
              ref={searchRef}
              data={forms}
              columns={column}
              onFilter={(filteredData ) => {
                setFilterData(filteredData)
              }}
              onSearchTermChange={ (searchValue: string)=>{ setSearchValue(searchValue) } }
            />
          )}
        </div>
      }
      onCancel={() => {
        setvisible(false);
      }}
      closeIcon={<Icon data-test-id="close" style={{ color: "white" }} type="close" />}
      destroyOnClose={true}
      footer={[
        <div key={"footer-1"}>
          <Button data-test-id="cancel" type="link" style={{ color: "#8797a8" }} onClick={() => { setvisible(false); dispatch(ModalSelectedValue(null)) }}>
            Cancel
          </Button>
          <Button
            data-test-id="create"
            //type="primary"
            disabled={activeTab === "1" ? (selFrom ? false : true) : false}
            className="modal-create-Button form_creation_save"
            onClick={() => {
              activeTab === "2" ? onSubmit() && setvisible(false) : SoloSelectedForms();
            }}
          >
            {activeTab === "2" ? "Save" : selFrom.formKey === selectedFromKey ? "Open" : "Select"}
          </Button>
        </div>,
      ]}
      visible={visible}
    >
      <Tabs
        data-test-id="form_tab"
        defaultActiveKey= {guideVisible ? "2" : "1"}
        onChange={(activeKey: string) => {
          searchRef.current?.clearSearch()
          setActiveTab(activeKey);
        }}
      >
        <TabPane data-test-id="choose_form" tab={<div style={{ textAlign: "center", width: "240px" }}>Choose Form</div>} key="1">
          {/* <div className="choose-card-tab-main"> */}
          {filteredData.length > 0 ?
            <div className="choose-card-tab">
              {filteredData.map((form: any, key: number) => {
                let { formName, updatedat, createdByName, formId, isV2, coreVersion } = form;
                return (
                  <div className="choose-card-main" key={key}>
                    <div data-test-id={`choose_card_checkbox${key}`} className="choose-card-checkbox">
                      <Checkbox
                        data-test-id="form_checkbox"
                        className="modal-Checkbox"
                        checked={selFrom.formId === formId}
                        onChange={() => {
                          selFrom.formId === formId ? setSelFrom("") : setSelFrom(form);
                        }}
                      ></Checkbox>
                    </div>
                    <div className="choose-card-main-inner">
                      <div className="choose-card-inner">
                        <div className="choose-card-Name">Form Name</div>
                        <div className="choose-card-value">{highlightMatch(formName, searchValue)}</div>
                      </div>
                      <div className="choose-card-inner">
                        <div className="choose-card-Name">Last Modified</div>
                        <div className="choose-card-value">{highlightMatch(moment(updatedat).local().format("DD-MM-YYYY hh:mm a"), searchValue)}</div>
                      </div>
                      <div className="choose-card-inner">
                        <div className="choose-card-Name">Created By</div>
                        <div className="choose-card-value">{highlightMatch(createdByName, searchValue)}</div>
                      </div>
                      <div style={{ marginTop: "10px", marginLeft: "70px" }}>
                        <div style={{
                          height: "24px", width: "62px", borderRadius: "4px", display: "flex", justifyContent: "center", alignItems: "center", fontWeight: 400, fontSize: "13px", lineHeight: "16px",
                          backgroundColor: isV2 === true ? (coreVersion === "v2" ? "rgba(241, 114, 46, 0.14)" : "#e3dcff") : "rgba(0, 40, 85, 0.12)", color: "#121212"
                        }}>
                          {highlightMatch(isV2 === false ? "Form v1" : ` Form ${coreVersion}`, searchValue)}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          : 
            <div className="flex items-center justify-center" style={{minHeight: "400px"}}>
              No Forms Available
            </div>
          }
          {/* </div> */}
        </TabPane>
        <TabPane data-test-id="create_form" tab={<div style={{ textAlign: "center", width: "240px" }}>Create Form</div>} key="2">
          <div style={{ padding: "0px 0px 145px 0px" }}>
            {!seletedAppType ?
              <Form
                data-test-id="new_form"
                appId={appId}
                getForms={getForms}
                // editInitialData={editInitialData}
                onSubmit={(submit: any) => (onSubmit = submit)}
                getSavedForm={getSavedForm}
                editable={editable}
              ></Form> :
              <SoloFrom
                data-test-id="new_form"
                appId={appId}
                getForms={getForms}
                // editInitialData={editInitialData}
                onSubmit={(submit: any) => (onSubmit = submit)}
                getSavedForm={getSavedForm}
                editable={editable}
              ></SoloFrom>}
          </div>
        </TabPane>
      </Tabs>
    </Modal >
  );
};
